import { memo } from 'react';
import styles from './Index.module.scss';

export const LatestNews = memo(() => {
  return (
    <section className={styles.newsContainer}>
      <h3 className={styles.newsHeading}>
        Our agents are rooted in local communities, but we proudly serve customers nationwide. As an affiliate of
        Wellabe - a financially strong organization with a legacy dating back to 1929 - we bring decades of experience
        and stability to everything we do.
      </h3>
    </section>
  );
});
